import React from "react"
import styled from "styled-components"

export const IconBox = styled.button`
  display: flex;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  color: ${props => props.theme.colors[props.color] || props.theme.colors.text};
  opacity: ${props => props.opacity};
  border: none;
  background-color: transparent;
  border-radius: ${props => props.borderRadius};
  width: ${props => props.width};
  height: ${props => props.height};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  padding: ${props => props.padding};
  margin-right: ${props => props.mr};
`

export const IconButton = ({ onClick, icon, color, ...props }) => {
  return (
    <IconBox onClick={onClick} color={color} {...props}>
      {icon}
    </IconBox>
  )
}
